import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import * as React from "react";
import {YesNo} from "../../admin/customFields/BooleanDisplay";
import Lead from "../../../model/lead/Lead";
import {Dispatch} from "redux";
import {editLead} from "../../../store/action/lead/lead";
import Toast from "../../helper/Toast";
import {connect} from "react-redux";
import {Option} from "ts-option";

interface ComponentProps {
	lead: Option<Lead>;
}

interface DispatchProps {
	editLead: (lead: Lead) => void
}

type Props = ComponentProps & DispatchProps

class PayByFinance extends React.PureComponent<Props> {
	render() {
		return (
			<InfoModule icon={Icon.Finance} title={"Paid by finance"}>
				<DropDown items={[YesNo.YES, YesNo.NO]}
						  itemToId={(item: string) => item}
						  itemToLabel={(item: string) => item}
						  selectedItemId={this.props.lead.map(l => l.data.payByFinance ? YesNo.YES : YesNo.NO).orNull}
						  onSelect={this.onSelect}/>
			</InfoModule>
		)
	}

	onSelect = (item: YesNo) => {
		this.props.lead.map(l => this.props.editLead(l.copy({data: l.data.copy({payByFinance: item === YesNo.YES})})))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead) => dispatch(
			editLead(
				lead,
				() => Toast.success("Lead pay by finance updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(PayByFinance)